import { render } from "./Testimonial.vue?vue&type=template&id=47e9f57c"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Components/Testimonial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47e9f57c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47e9f57c', __exports__)) {
    api.reload('47e9f57c', __exports__)
  }
  
  module.hot.accept("./Testimonial.vue?vue&type=template&id=47e9f57c", () => {
    api.rerender('47e9f57c', render)
  })

}


export default __exports__